<template>
  <div class="admin-consumers">
    <admin-template
      :endpointUrl="endpointUrl"
      :title="title"
      :tableSort="{prop: 'id', order: 'ascending'}"
      :visibleTenantsSelect="false"
      :visibleSearch="false"
    >
      <template slot="table-columns">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="id" prop="id" class-name="hidden-cell" width="55" sortable></el-table-column>
        <el-table-column label="アイコン" width="300">
          <template slot-scope="scope">
            <img :src="iconImageUrl(scope.row)"></template>
        </el-table-column>
        <el-table-column prop="name" label="認証連携アプリケーション名" sortable>
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" size="small" @click="onClickEditButton(scope.row.id)">編集</el-button>
            <el-button size="small" @click="onClickFederateDataEditButton(scope.row.id)">連携用データの設定</el-button>
            <el-button size="small" @click="onClickIconButton(scope.row)">アイコンの設定</el-button>
          </template>
        </el-table-column>
      </template>
    </admin-template>

    <admin-dialog
      :endpointUrl="endpointDetailUrl"
      :endpointBulkDeleteUrl="endpointBulkDeleteUrl"
      :title="title"
      :form="form"
      :selection="selection"
    >
      <template slot="dialogFormItem" slot-scope="{isEdit}">
        <el-form-item label="アプリケーション名" prop="name">
          <el-input v-model="form.data.name" auto-complete="off" :autofocus="true"></el-input>
        </el-form-item>
        <el-form-item label="クライアントID" prop="client_id">
          <el-input v-model="form.data.client_id" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="秘密鍵" prop="client_secret">
          <el-input v-model="form.data.client_secret" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="許可する戻り先URL" prop="redirect_uris">
          <el-input type="textarea" :rows="4" v-model="form.data.redirect_uris"></el-input>
        </el-form-item>
        <el-form-item label="ログインURL" prop="login_url">
          <el-input v-model="form.data.login_url"></el-input>
        </el-form-item>
        <el-form-item label="問い合わせ先URL" prop="inquiry_url">
          <el-input v-model="form.data.inquiry_url"></el-input>
        </el-form-item>
      </template>
    </admin-dialog>

    <div class="federateData">
      <el-dialog
        class="federateData-dialog"
        title="連携用データの設定"
        :visible.sync="federateDataDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <el-button type="primary" @click="addJsonSchemaData">追加</el-button>
        <table v-if="federateDataDialog.form.length > 0">
          <thead>
            <tr>
              <th>キー名</th>
              <th>説明</th>
              <th>型</th>
              <th>デフォルト値</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in federateDataDialog.form" v-bind:key="index">
              <td>
                <el-input v-model="item.key"></el-input>
              </td>
              <td>
                <el-input v-model="item.title"></el-input>
              </td>
              <td>
                <el-select
                  v-model="item.type"
                  @change="item.default = item.type==='integer' ? 0 : item.type==='boolean' ? false : ''"
                >
                  <el-option
                    v-for="type in schemaTypes"
                    :key="type.value"
                    :label="type.label"
                    :value="type.value"
                  ></el-option>
                </el-select>
              </td>
              <td>
                <el-input-number v-if="item.type === 'integer'" placeholder v-model="item.default"></el-input-number>
                <el-switch v-else-if="item.type === 'boolean'" placeholder v-model="item.default"></el-switch>
                <el-input v-else v-model="item.default"></el-input>
              </td>
              <td>
                <el-button type="danger" @click="removeJsonSchemaData(index)">削除</el-button>
              </td>
            </tr>
          </tbody>
        </table>

        <el-alert
          v-if="federateDataDialog.isAlert"
          :title="federateDataDialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleFederateDataRegister"
            :loading="federateDataDialog.loading"
          >OK</el-button>
          <el-button @click="handleFederateDataCancel">キャンセル</el-button>
        </span>
      </el-dialog>
    </div>

    <el-dialog
      :title="iconDialog.title"
      :visible.sync="iconDialog.visible"
      :close-on-click-modal="false"
      class="upload-dialog"
    >
      <el-card>
        <div slot="header">
          <div class="header-title">新しいアイコン</div>
          <div class="button-group">
            <el-upload
              class="upload"
              ref="upload"
              :action="iconDialog.actionUrl"
              name="image"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :show-file-list="false"
              :headers="xsrfHeaders"
            >
              <el-button slot="trigger" icon="el-icon-upload">アイコン画像(SVG)を選択</el-button>
            </el-upload>
          </div>
        </div>
        <div class="center">
          <img
            v-if="iconDialog.imageUrl.length > 0"
            class="consumer-icon"
            :src="iconDialog.imageUrl"
          >
        </div>
      </el-card>
      <el-alert
        v-if="iconDialog.isAlert"
        :title="iconDialog.errorMessage"
        type="error"
        show-icon
        :closable="false"
      ></el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitUpload"
          :disabled="iconDialog.imageUrl.length === 0"
          :loading="iconDialog.loading"
        >OK</el-button>
        <el-button @click="handleUploadCancel">キャンセル</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AdminTemplate from "@/components/admin/Template";
import AdminDialog from "@/components/admin/Dialog";
import { AdminEventBus } from "@/components/admin/EventBus";
import axios from "axios";

export default {
  components: {
    AdminTemplate,
    AdminDialog
  },
  data() {
    const endpointUrl = "/api/consumers/simple/";
    const endpointDetailUrl = "/api/consumers/detail/";
    const endpointBulkDeleteUrl = "/api/consumers/app-bulk/";
    const title = "認証連携アプリケーション管理";
    const initialFormData = {
      id: 0,
      name: ""
    };
    const rule = {
      name: [
        {
          required: true,
          message: "連携アプリケーション名を入力してください",
          trigger: "blur"
        }
      ]
    };

    return {
      title,
      endpointUrl,
      endpointDetailUrl,
      endpointBulkDeleteUrl,
      form: {
        ref: "adminConsumerForm",
        labelWidth: "150px",
        data: Object.assign({}, initialFormData),
        rules: {
          create: rule,
          update: rule
        }
      },
      selection: [],
      federateDataDialog: {
        visible: false,
        target: 0,
        form: [],
        loading: false,
        errorMessage: "",
        isAlert: false
      },
      iconDialog: {
        visible: false,
        actionUrl: "",
        title: "",
        form: [],
        imageUrl: "",
        loading: false,
        errorMessage: "",
        isAlert: false
      },
      schemaTypes: [
        { value: "string", label: "文字列" },
        { value: "integer", label: "整数" },
        { value: "boolean", label: "真偽値" }
      ]
    };
  },
  computed: {
    schema: {
      get: function() {
        const o = this.federateDataDialog.form.reduce((obj, item) => {
          obj[item.key] = {
            title: item.title,
            type: item.type,
            default: item.default
          };
          return obj;
        }, {});
        return { type: "object", properties: o };
      },
      set: function(value) {
        //this.tableData = this.schemaOrder.map((el, i, array) => {
        if (value !== undefined && value !== "") {
          this.federateDataDialog.form = Object.keys(value.properties).map(
            (el, i, array) => {
              return {
                key: el,
                title: value.properties[el].title,
                type: value.properties[el].type,
                default: value.properties[el].default
              };
            }
          );
        } else {
          this.federateDataDialog.form = Object.assign([]);
        }
      }
    },
    xsrfHeaders: function() {
      for (let c of document.cookie.split("; ")) {
        if (c.startsWith("csrftoken=")) {
          return { "X-CSRFToken": c.slice(10) };
        }
      }
      return {};
    }
  },
  created() {
    AdminEventBus.$on("init-form", () => {
      this.initForm();
    });
  },
  methods: {
    removeJsonSchemaData(index) {
      this.federateDataDialog.form.splice(index, 1);
    },
    addJsonSchemaData() {
      this.federateDataDialog.form.push({
        key: "",
        title: "",
        type: "string",
        default: ""
      });
    },
    initForm() {
      this.form.data = Object.assign({}, this.initialFormData);
    },
    onClickEditButton(id) {
      axios.get(`${this.endpointDetailUrl}${id}/`).then(response => {
        this.form.data = response.data;
        AdminEventBus.$emit("click-edit");
      });
    },
    onClickFederateDataEditButton(id) {
      axios
        .get(`${this.endpointDetailUrl}${id}/federation-data/`)
        .then(response => {
          try {
            this.schema = JSON.parse(response.data.configJsonSchema);
          } catch (error) {
            this.schema = "";
          }
          this.federateDataDialog.target = id;
          this.federateDataDialog.isAlert = false;
          this.federateDataDialog.visible = true;
        })
        .catch(error => {
          console.log(error);
          this.federateDataDialog.errorMessage =
            "連携用データの取得に失敗しました。";
          this.federateDataDialog.isAlert = true;
        });
    },
    onClickIconButton(row) {
      this.iconDialog.imageUrl = "";
      this.iconDialog.target = row.id;
      this.iconDialog.actionUrl = `/api/consumers/icons/${row.id}/`;
      this.iconDialog.isAlert = false;
      this.iconDialog.visible = true;
      this.iconDialog.title = `${row.name}のアイコン設定`;
    },

    handleFederateDataRegister() {
      let data = { configJsonSchema: JSON.stringify(this.schema) };
      axios
        .put(
          `${this.endpointDetailUrl}${
            this.federateDataDialog.target
          }/federation-data/`,
          data
        )
        .then(response => {});
      this.federateDataDialog.visible = false;
    },
    handleFederateDataCancel() {
      this.federateDataDialog.form = Object.assign([]);
      this.federateDataDialog.visible = false;
    },
    beforeUpload(file) {
      return true;
    },
    submitUpload() {
      if (this.iconDialog.imageUrl.length > 0) {
        // 画像ファイルのアップロード
        this.iconDialog.loading = true;
        this.$refs.upload.submit();
        this.iconDialog.loading = false;
      }
    },
    handleUploadCancel() {
      this.iconDialog.visible = false;
    },
    handleUploadSuccess(res, file) {
      this.$refs.upload.clearFiles();
      this.iconDialog.visible = false;
      AdminEventBus.$emit("refresh");
    },
    handleUploadError(err, res, file) {
      this.iconDialog.errorMessage = "エラーが発生しました。";
      console.log(err);
    },
    onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.shift();
      }
      this.iconDialog.imageUrl = URL.createObjectURL(file.raw);
    },
    iconImageUrl(row) {
      return `/api/consumers/icons/${row.id}/?${row.update_timestamp}`;
    }
  }
};
</script>

<style scoped>
.header-title {
  display: inline-block;
  vertical-align: middle;
  margin: 12px;
}
.button-group {
  display: inline-block;
  float: right;
}
.center {
  text-align: center;
  vertical-align: middle;
}
.upload-dialog >>> .el-dialog {
  width: 500px;
}
.upload-dialog .consumer-icon {
  width: 200px;
  height: 200px;
}
.upload-dialog >>> .el-card__header {
  padding-top: 12px;
  padding-bottom: 12px;
}
.upload-dialog >>> .el-card__body {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
}
</style>


